<template>
    <div class="calendar-toolbox">
        <div class="btnGroup">
            <SupsisButton
                :classNames="mode === 'upcoming' ? 'btnGroupItem selected' : 'btnGroupItem '"
                :primary="mode === 'upcoming'"
                :ghost="mode !== 'upcoming'"
                @click="() => changeMode('upcoming')"
            >
                {{ $t("calendar.upcoming") }}
            </SupsisButton>
            <SupsisButton
                :classNames="mode === 'past' ? 'btnGroupItem selected' : 'btnGroupItem '"
                :primary="mode === 'past'"
                :ghost="mode !== 'past'"
                @click="() => changeMode('past')"
            >
                {{ $t("calendar.past") }}
            </SupsisButton>
        </div>
        <div>
            <h2>{{ getTitle() }}</h2>
        </div>
        <div class="right">
            <a-popover
                placement="bottom"
                overlayClassName="calendar-picker-popover zero-padding p-0"
                :visible="calendarPickerVisible"
            >
                <template #content>
                    <CalendarPickerReservation
                        v-if="type === 'reservation'"
                        v-model="selectedCalendarId"
                        :reservationPlans="reservationPlans"
                    />
                    <CalendarPicker v-model="selectedCalendarId" v-else />
                </template>
                <SupsisButton ghost @click="() => (calendarPickerVisible = !calendarPickerVisible)">
                    <i class="material-icons">filter_list</i>
                    <span v-if="selectedCalendarId === 'my'">{{ $t("calendar.myEvents") }}</span>
                    <span v-else-if="selectedCalendarId === 'everyone'">{{ $t("calendar.everyoneEvents") }}</span>
                    <span v-else
                        >{{ getUserName(selectedCalendarId) }}
                        {{ type === "reservation" ? "" : $t("calendar.haveEvent") }}</span
                    >
                    <i class="material-icons" v-if="!calendarPickerVisible">arrow_drop_down</i>
                    <i class="material-icons" v-else>arrow_drop_up</i>
                </SupsisButton>
            </a-popover>
            <SupsisButton ghost @click="goCalendarPage" v-if="type !== 'reservation'">
                <span class="material-icons calendar-icon">edit_calendar</span>
                <span class="btn-label">{{ $t("calendar.goCalendar") }}</span>
            </SupsisButton>
            <SupsisButton ghost @click="goReservationPage" v-else class="new-reservation-button">
                <span class="material-icons calendar-icon">calendar_month</span>
                <span class="btn-label">{{ $t("calendar.goReservation") }}</span>
            </SupsisButton>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";
import { mapGetters, mapState } from "vuex";
import CalendarPicker from "./CalendarPicker.vue";
import CalendarPickerReservation from "./CalendarPickerReservation.vue";
import moment from "moment/moment";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";

export default Vue.extend({
    name: "CalendarEventsToolbox",
    components: { CalendarPicker, AgentAvatar, SupsisButton, CalendarPickerReservation },
    props: {
        defaultSelectedCalendarId: {
            type: String,
            default: "my",
        },
        mode: {
            type: String,
            default: "upcoming",
        },
        type: {
            type: String,
            default: "calendar",
        },
        reservationPlans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            calendarPickerVisible: false,
            search: "",
            selectedCalendarId: this.defaultSelectedCalendarId,
        };
    },
    mounted() {
        this.selectedCalendarId = this.defaultSelectedCalendarId;
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        isCalendarUpdatePermission() {
            return this.checkPermission(PERMISSION_TYPES["calendar.update"].tr.name);
        },
    },
    methods: {
        getTitle() {
            const name = this.type === "reservation" ? this.$t("calendar.reservations") : this.$t("calendar.events");
            if (this.mode === "upcoming") return `${this.$t("calendar.upcoming")} ${name}`;
            if (this.mode === "past") return `${this.$t("calendar.past")} ${name}`;
            return "Events";
        },
        getUserName(id) {
            if (this.type === "reservation") {
                const reservation = this.reservationPlans.find((x) => x._id === id);
                return reservation ? reservation.title : "";
            } else {
                const user = this.users.find((user) => user._id === id);
                return user ? user.name : "";
            }
        },
        changeMode(mode) {
            this.$emit("changeMode", mode);
        },
        goCalendarPage() {
            this.$router.replace(`/calendar/d/${moment().format().split("T")[0]}`);
        },
        goReservationPage() {
            if (this.isCalendarUpdatePermission) {
                this.$router.replace(`/reservation`);
            } else {
                this.$message.error(this.$t("noPermission"));
            }
        },
    },
    watch: {
        defaultSelectedCalendarId() {
            if (this.defaultSelectedCalendarId !== this.selectedCalendarId)
                this.selectedCalendarId = this.defaultSelectedCalendarId;
        },
        selectedCalendarId() {
            console.log("watch selectedCalendarId", this.selectedCalendarId);
            this.$emit("calendarChange", this.selectedCalendarId);
            this.calendarPickerVisible = false;
        },
    },
});
</script>
<style lang="scss">
.calendar-picker-popover {
    .ant-popover-inner-content {
        padding: 0 !important;
        box-shadow: var(--shadow-dropdown-400);
        border: 1px solid var(--color-border-default);
        border-radius: 5px;
    }
}
</style>

<style scoped lang="scss">
.calendar-toolbox {
    display: flex;
    justify-content: space-between;
    align-items: center;

    #avatar-placeholder {
        font-size: 14px !important;
    }

    .btnGroup {
        display: flex;
        border: 1px solid var(--color-border-default);
        border-radius: 6px;
        background: var(--color-bg-neutral-default);
        padding: 2px;

        .btnGrupItem {
            &.selected {
                background: var(--color-bg-oncomponent-default);
                box-shadow: var(--shadow-interaction-200);
            }
        }

        .supsis-button {
            border: none !important;
            font-size: 14px;
        }
    }

    .right {
        display: flex;
        align-items: center;
        gap: 5px;
    }
}
</style>
